var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-loader"},[_c('div',{staticClass:"inline-loader__spinner"},[_c('div',{staticClass:"lds-ring"},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"lds-ring__el"})}),0)]),_c('div',{staticClass:"inline-loader__label"},[_vm._v(_vm._s(_vm.computedLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }